import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const ChevronUnconstrained: FC<IconSvgProps> = ({ color, clss }) => {
    return (
        <svg style={{ display: 'inline-flex' }} className={clss} width="12" height="9" viewBox="-4 0 12 9">
            <g fill={color} fillRule="evenodd">
                <g fill={color}>
                    <g>
                        <path d="M0 1.026L2.956 4 0 6.974 1.024 8 4.49 4.513 5 4 4.49 3.487 1.025 0z" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default ChevronUnconstrained;
